import { useState, useRef, useEffect } from "react";
import { X } from "@phosphor-icons/react";
import api from "@/lib/api";

export const RecipientInput = ({ label, value, onChange, testId, placeholder }) => {
  const [input, setInput] = useState("");
  const [sug, setSug] = useState([]);
  const [open, setOpen] = useState(false);
  const [hi, setHi] = useState(0);
  const tRef = useRef(null);

  useEffect(() => {
    if (!input.trim()) { setSug([]); setOpen(false); return; }
    clearTimeout(tRef.current);
    tRef.current = setTimeout(async () => {
      try {
        const { data } = await api.get("/contacts/suggest", { params: { q: input.trim() } });
        const filtered = data.filter((s) => !value.includes(s.email));
        setSug(filtered); setOpen(filtered.length > 0); setHi(0);
      } catch { setSug([]); }
    }, 180);
    return () => clearTimeout(tRef.current);
  }, [input, value]);

  const add = (email) => {
    const e = email.trim().replace(/,$/, "");
    if (e && !value.includes(e)) onChange([...value, e]);
    setInput(""); setOpen(false);
  };
  const onKey = (e) => {
    if (open && e.key === "ArrowDown") { e.preventDefault(); setHi((h) => Math.min(h + 1, sug.length - 1)); }
    else if (open && e.key === "ArrowUp") { e.preventDefault(); setHi((h) => Math.max(h - 1, 0)); }
    else if (e.key === "Enter") { e.preventDefault(); if (open && sug[hi]) add(sug[hi].email); else if (input.trim()) add(input); }
    else if (e.key === ",") { e.preventDefault(); if (input.trim()) add(input); }
    else if (e.key === "Backspace" && !input && value.length) onChange(value.slice(0, -1));
    else if (e.key === "Escape") setOpen(false);
  };

  return (
    <div className="relative mb-4">
      <label className="text-xs font-medium text-gray-500 block mb-1">{label}</label>
      <div className="w-full border border-gray-300 rounded-md px-2 py-1.5 flex flex-wrap gap-1.5 items-center focus-within:ring-2 focus-within:ring-blue-500 bg-white min-h-[42px]">
        {value.map((v, i) => (
          <span key={i} data-testid={`${testId}-chip-${i}`}
            className="flex items-center gap-1 bg-blue-50 text-blue-700 border border-blue-200 rounded-full px-2 py-0.5 text-xs font-medium">
            {v}
            <button data-testid={`${testId}-chip-remove-${i}`} onClick={() => onChange(value.filter((_, j) => j !== i))}
              className="text-blue-400 hover:text-red-500"><X size={11} /></button>
          </span>
        ))}
        <input data-testid={testId} value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={onKey}
          onBlur={() => setTimeout(() => { setOpen(false); }, 150)}
          placeholder={value.length === 0 ? placeholder : ""}
          className="flex-1 min-w-[140px] text-sm py-1 focus:outline-none" />
      </div>
      {open && (
        <div data-testid={`${testId}-suggestions`}
          className="absolute z-20 left-0 right-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-52 overflow-y-auto">
          {sug.map((s, i) => (
            <button key={s.email} data-testid={`${testId}-suggestion-${i}`}
              onMouseDown={(e) => { e.preventDefault(); add(s.email); }}
              className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 ${i === hi ? "bg-blue-50" : "hover:bg-gray-50"}`}>
              <span className="w-6 h-6 rounded-full bg-gray-200 text-gray-600 text-[10px] font-bold flex items-center justify-center shrink-0">
                {(s.name || s.email)[0].toUpperCase()}
              </span>
              <span className="font-medium text-gray-800 whitespace-pre"> {s.name || s.email} </span>
              <span className="text-xs text-gray-400 truncate">{s.email}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
